function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M254.128 561.875H69.9455C53.461 561.875 40.0938 548.508 40.0938 532.023V127.941C40.0938 111.457 53.461 98.0894 69.9455 98.0894H254.128C270.613 98.0894 283.98 111.457 283.98 127.941V532.041C283.963 548.508 270.613 561.875 254.128 561.875Z",
  fill: "#0961BF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M255.891 550.375H68.1857C58.5169 550.375 50.6797 542.538 50.6797 532.869V127.096C50.6797 117.427 58.5169 109.59 68.1857 109.59H255.891C265.56 109.59 273.397 117.427 273.397 127.096V532.869C273.397 542.538 265.56 550.375 255.891 550.375Z",
  fill: "#EBE3FF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M106.058 83.0668C106.235 112.355 82.6173 136.236 53.3291 136.395C24.0409 136.571 0.159484 112.954 0.000978622 83.6656C-0.175138 54.3773 23.4421 30.4959 52.7303 30.3374C82.0185 30.1613 105.9 53.7785 106.058 83.0668Z",
  fill: "#3684D9"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M92.498 82.3094C92.6213 104.571 74.675 122.728 52.4138 122.851C30.1526 122.975 11.995 105.028 11.8717 82.7673C11.7484 60.5061 29.6948 42.3485 51.9559 42.2252C74.2171 42.0843 92.3747 60.0306 92.498 82.3094Z",
  fill: "#0B519D"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M93.656 83.982C93.7793 105.944 76.0796 123.855 54.1179 123.978C32.1561 124.101 14.245 106.402 14.1217 84.4399C13.9985 62.4782 31.6982 44.5671 53.6599 44.4438C75.6217 44.3029 93.5328 62.0027 93.656 83.982Z",
  fill: "#FF725E"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M93.656 83.982C93.7793 105.944 76.0796 123.855 54.1179 123.978C32.1561 124.101 14.245 106.402 14.1217 84.4399C13.9985 62.4782 31.6982 44.5671 53.6599 44.4438C75.6217 44.3029 93.5328 62.0027 93.656 83.982Z",
  fill: "#0961BF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4472 80.7413L55.3944 70.5618C55.412 70.5618 55.4296 70.5618 55.4472 70.5618C57.2084 70.7555 59.0576 71.2134 60.8716 71.9355C62.3862 72.7104 63.4077 73.5206 63.4077 73.5206L63.5486 73.2036L65.0984 69.5227L65.4507 68.6774L63.6191 66.7753L62.7561 67.1804C60.5194 66.0884 57.9833 65.2255 55.3768 65.1022L55.3416 59.5017L53.598 58.1104V59.5193L51.1852 59.5369L51.2205 65.2255C43.3656 66.0356 39.6496 70.5266 39.6848 75.6692C39.72 82.6786 45.7432 84.4574 51.3437 85.7783L51.3966 95.8698C47.5572 95.5352 43.7707 94.091 41.2875 92.1009L39.0508 97.2083C41.6925 99.4626 46.4829 101.048 51.4318 101.329L51.4494 105.556L49.4769 105.609L51.4494 106.93L55.5881 106.912L55.5529 101.259C63.4605 100.414 67.2118 95.9402 67.1942 90.7976C67.159 83.8058 61.0478 82.0798 55.4472 80.7413ZM51.3085 79.7023C48.385 78.8569 46.2011 77.765 46.1835 75.3522C46.1659 73.1331 47.6805 71.3191 51.2557 70.7379L51.3085 79.7023ZM55.5353 95.7641L55.4825 86.835C58.5117 87.6803 60.7307 88.8251 60.7483 91.2907C60.766 93.4746 59.2161 95.2005 55.5353 95.7641Z",
  fill: "#71B7E2"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M53.8479 99.8862L53.8831 105.54L49.7443 105.557L49.7091 99.9567C44.7602 99.6749 39.9699 98.0898 37.3281 95.8355L39.5648 90.7281C42.048 92.7359 45.8346 94.1624 49.6739 94.497L49.6211 84.4056C44.0206 83.0847 37.9974 81.2883 37.9621 74.2965C37.9269 69.1538 41.643 64.6453 49.4978 63.8351L49.4626 58.1289L53.6013 58.1113L53.6365 63.7118C57.3702 63.888 61.1567 64.9799 63.8865 66.7234L61.8436 71.8308C59.1666 70.281 56.3311 69.4356 53.6541 69.1538L53.707 79.3334C59.3075 80.6543 65.4187 82.3978 65.4716 89.4073C65.5244 94.5851 61.7555 99.0409 53.8479 99.8862ZM49.5858 78.3295L49.533 69.3476C45.9578 69.9288 44.4608 71.7428 44.4608 73.9618C44.4784 76.3922 46.6623 77.5018 49.5858 78.3295ZM59.0433 89.9356C59.0257 87.47 56.8066 86.3252 53.7774 85.4799L53.8303 94.409C57.4935 93.8278 59.0433 92.1018 59.0433 89.9356Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M196.761 33.876C196.867 52.4387 181.915 67.5671 163.352 67.6728C144.789 67.7784 129.661 52.8261 129.555 34.2634C129.45 15.7007 144.402 0.572291 162.965 0.466621C181.527 0.360951 196.656 15.3133 196.761 33.876Z",
  fill: "#3684D9"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M166.488 58.7863C180.429 56.651 190 43.6183 187.864 29.6768C185.729 15.7353 172.696 6.16455 158.755 8.29985C144.814 10.4351 135.243 23.4679 137.378 37.4094C139.513 51.3508 152.546 60.9216 166.488 58.7863Z",
  fill: "#0B519D"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M188.872 34.4575C188.96 48.3707 177.741 59.7126 163.828 59.8007C149.915 59.8888 138.573 48.6701 138.485 34.7393C138.397 20.8261 149.615 9.48414 163.546 9.39608C177.442 9.32564 188.784 20.5443 188.872 34.4575Z",
  fill: "#FF725E"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M188.872 34.4575C188.96 48.3707 177.741 59.7126 163.828 59.8007C149.915 59.8888 138.573 48.6701 138.485 34.7393C138.397 20.8261 149.615 9.48414 163.546 9.39608C177.442 9.32564 188.784 20.5443 188.872 34.4575Z",
  fill: "#0961BF"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M164.674 32.4141L164.639 25.9682C164.657 25.9682 164.657 25.9682 164.674 25.9682C165.801 26.0915 166.964 26.3909 168.108 26.8488C169.077 27.3419 169.711 27.8527 169.711 27.8527L169.799 27.6589L170.785 25.3342L171.014 24.8058L169.852 23.6082L169.306 23.8548C167.897 23.1503 166.277 22.622 164.621 22.5339L164.604 18.994L163.494 18.1134V19.0116H161.98L161.997 22.622C157.013 23.1327 154.671 25.9858 154.688 29.244C154.706 33.6821 158.528 34.8093 162.068 35.6546L162.103 42.0477C159.672 41.8363 157.277 40.9205 155.692 39.6525L154.266 42.893C155.939 44.3196 158.968 45.3234 162.103 45.4995L162.12 48.1765L160.87 48.2117L162.12 49.0571L164.745 49.0395L164.727 45.4643C169.746 44.9184 172.124 42.1005 172.106 38.8423C172.106 34.3514 168.232 33.2594 164.674 32.4141ZM162.05 31.7448C160.201 31.2165 158.809 30.512 158.809 28.9798C158.809 27.5709 159.76 26.4261 162.015 26.0563L162.05 31.7448ZM164.745 41.9244L164.709 36.271C166.629 36.7994 168.038 37.5215 168.056 39.0889C168.056 40.4626 167.069 41.5545 164.745 41.9244Z",
  fill: "#71B7E2"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M163.7 44.5316L163.717 48.1068L161.093 48.1244L161.075 44.5844C157.941 44.4083 154.911 43.4044 153.238 41.9779L154.665 38.7374C156.232 40.0054 158.645 40.9212 161.075 41.1325L161.04 34.7395C157.483 33.8941 153.679 32.767 153.661 28.3288C153.643 25.0707 155.986 22.2176 160.97 21.7069L160.952 18.0965L163.576 18.0789L163.594 21.6188C165.954 21.7245 168.367 22.429 170.093 23.5385L168.807 26.779C167.116 25.7928 165.32 25.2644 163.629 25.0883L163.664 31.5342C167.222 32.3795 171.079 33.4715 171.114 37.9096C171.097 41.1678 168.701 44.0032 163.7 44.5316ZM161.005 30.8826L160.97 25.194C158.698 25.5638 157.747 26.7086 157.764 28.1175C157.764 29.6497 159.138 30.3542 161.005 30.8826ZM166.975 38.2266C166.958 36.6592 165.549 35.9371 163.629 35.4087L163.664 41.0621C166.007 40.6922 166.993 39.6003 166.975 38.2266Z",
  fill: "white"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M341.351 194.073H109.352C101.814 194.073 95.7031 200.184 95.7031 207.722V209.853V328.45C95.7031 335.988 101.814 342.099 109.352 342.099H341.351C348.889 342.099 355 335.988 355 328.45V307.034V207.705C355 200.184 348.889 194.073 341.351 194.073Z",
  fill: "#9FCCFB"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M335.347 337.362H103.348C95.8105 337.362 89.6992 331.25 89.6992 323.713V202.985C89.6992 195.447 95.8105 189.336 103.348 189.336H335.347C342.885 189.336 348.996 195.447 348.996 202.985V323.713C348.996 331.25 342.885 337.362 335.347 337.362Z",
  fill: "#3684D9"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M348.996 202.985C348.996 195.447 342.885 189.336 335.347 189.336H103.348C95.8105 189.336 89.6992 195.447 89.6992 202.985V205.116C118.089 206.401 173.126 215.718 211.519 264.995C255.707 321.722 315.076 316.175 348.996 302.314V202.985Z",
  fill: "#0961BF"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M148.591 271.864H116.203C113.333 271.864 111.008 269.539 111.008 266.668V249.708C111.008 246.838 113.333 244.513 116.203 244.513H148.591C151.462 244.513 153.787 246.838 153.787 249.708V266.668C153.787 269.539 151.462 271.864 148.591 271.864Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M331.15 215.771H284.25C283.07 215.771 282.102 214.802 282.102 213.622V204.587C282.102 203.407 283.07 202.439 284.25 202.439H331.15C332.33 202.439 333.299 203.407 333.299 204.587V213.622C333.299 214.802 332.348 215.771 331.15 215.771Z",
  fill: "#1C004F"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M154.142 294.988H114.005C111.504 294.988 109.461 292.963 109.461 290.444C109.461 287.943 111.486 285.901 114.005 285.901H154.142C156.643 285.901 158.686 287.926 158.686 290.444C158.686 292.945 156.643 294.988 154.142 294.988Z",
  fill: "white"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M210.954 294.988H170.817C168.316 294.988 166.273 292.963 166.273 290.444C166.273 287.943 168.299 285.901 170.817 285.901H210.954C213.455 285.901 215.498 287.926 215.498 290.444C215.498 292.945 213.455 294.988 210.954 294.988Z",
  fill: "white"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M268.196 294.988H228.059C225.559 294.988 223.516 292.963 223.516 290.444C223.516 287.943 225.541 285.901 228.059 285.901H268.196C270.697 285.901 272.74 287.926 272.74 290.444C272.74 292.945 270.697 294.988 268.196 294.988Z",
  fill: "white"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M325.009 294.988H284.872C282.371 294.988 280.328 292.963 280.328 290.444C280.328 287.943 282.353 285.901 284.872 285.901H325.009C327.51 285.901 329.553 287.926 329.553 290.444C329.553 292.945 327.51 294.988 325.009 294.988Z",
  fill: "white"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M166.822 325.615H114.621C113.088 325.615 111.855 324.382 111.855 322.85C111.855 321.318 113.088 320.085 114.621 320.085H166.822C168.354 320.085 169.587 321.318 169.587 322.85C169.587 324.382 168.336 325.615 166.822 325.615Z",
  fill: "#1C004F"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M324.863 325.615H299.097C297.565 325.615 296.332 324.382 296.332 322.85C296.332 321.318 297.565 320.085 299.097 320.085H324.863C326.395 320.085 327.628 321.318 327.628 322.85C327.628 324.382 326.395 325.615 324.863 325.615Z",
  fill: "#1C004F"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M118.815 244.055C122.602 248.916 128.608 259.976 118.305 272.586",
  stroke: "#8EC3F4",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M108.262 257.951H123.954",
  stroke: "#8EC3F4",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M144.808 244.055C141.022 248.916 135.016 259.976 145.319 272.586",
  stroke: "#8EC3F4",
  strokeWidth: 0.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M155.348 257.951H139.656",
  stroke: "#8EC3F4",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref31 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.35
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.35
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.35
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.35
}, /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M221.303 451.948C222.175 423.191 199.569 399.172 170.812 398.3C142.055 397.428 118.036 420.034 117.164 448.791C116.293 477.548 138.898 501.567 167.655 502.439C196.412 503.311 220.431 480.705 221.303 451.948Z",
  fill: "#9FCCFB"
})))));

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M217.429 449.591C219.036 420.571 196.814 395.743 167.795 394.136C138.775 392.529 113.947 414.751 112.34 443.77C110.733 472.79 132.955 497.618 161.974 499.225C190.994 500.833 215.822 478.61 217.429 449.591Z",
  fill: "#3684D9"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M172.394 484.96C193.993 480.334 207.752 459.075 203.127 437.477C198.501 415.878 177.242 402.118 155.643 406.744C134.045 411.369 120.285 432.628 124.91 454.227C129.536 475.826 150.795 489.585 172.394 484.96Z",
  fill: "#0B519D"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M205.178 447.311C205.302 469.096 187.743 486.866 165.94 487.007C144.136 487.131 126.384 469.572 126.243 447.769C126.12 425.983 143.678 408.213 165.482 408.072C187.285 407.949 205.055 425.507 205.178 447.311Z",
  fill: "#FF725E"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M205.178 447.311C205.302 469.096 187.743 486.866 165.94 487.007C144.136 487.131 126.384 469.572 126.243 447.769C126.12 425.983 143.678 408.213 165.482 408.072C187.285 407.949 205.055 425.507 205.178 447.311Z",
  fill: "#0961BF"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M167.271 444.105L167.218 434.014C167.236 434.014 167.254 434.014 167.271 434.014C169.032 434.208 170.846 434.666 172.643 435.388C174.14 436.163 175.161 436.955 175.161 436.955L175.285 436.638L176.817 432.992L177.169 432.147L175.355 430.263L174.492 430.65C172.273 429.558 169.755 428.713 167.166 428.59L167.13 423.042L165.387 421.651V423.042L163.009 423.059L163.044 428.713C155.243 429.505 151.562 433.979 151.597 439.086C151.632 446.043 157.602 447.804 163.168 449.125L163.221 459.128C159.416 458.794 155.665 457.367 153.2 455.377L150.98 460.449C153.587 462.686 158.36 464.253 163.256 464.535L163.273 468.727L161.319 468.779L163.273 470.1L167.377 470.083L167.342 464.482C175.197 463.637 178.913 459.216 178.895 454.109C178.877 447.135 172.819 445.426 167.271 444.105ZM163.15 443.066C160.244 442.239 158.078 441.147 158.078 438.751C158.06 436.55 159.557 434.736 163.097 434.172L163.15 443.066ZM167.342 459.005L167.289 450.146C170.3 450.974 172.502 452.119 172.52 454.567C172.537 456.733 171.005 458.441 167.342 459.005Z",
  fill: "#71B7E2"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M165.68 463.091L165.715 468.691L161.611 468.709L161.576 463.161C156.68 462.897 151.907 461.312 149.301 459.075L151.52 454.003C153.985 455.993 157.737 457.42 161.541 457.754L161.488 447.751C155.923 446.43 149.97 444.669 149.917 437.712C149.882 432.605 153.563 428.131 161.365 427.339L161.33 421.686L165.433 421.668L165.468 427.216C169.167 427.392 172.936 428.466 175.648 430.21L173.622 435.282C170.963 433.75 168.163 432.904 165.504 432.622L165.556 442.731C171.122 444.052 177.18 445.761 177.215 452.717C177.268 457.825 173.534 462.245 165.68 463.091ZM161.47 441.71L161.418 432.798C157.878 433.362 156.381 435.176 156.398 437.378C156.398 439.79 158.547 440.882 161.47 441.71ZM170.84 453.21C170.822 450.762 168.621 449.618 165.609 448.79L165.662 457.649C169.308 457.067 170.84 455.359 170.84 453.21Z",
  fill: "white"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M204.734 430.369C216.572 430.369 226.168 420.772 226.168 408.935C226.168 397.098 216.572 387.502 204.734 387.502C192.897 387.502 183.301 397.098 183.301 408.935C183.301 420.772 192.897 430.369 204.734 430.369Z",
  fill: "#E4F1FF"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M197.492 408.477L200.363 414.923C200.662 415.575 201.525 415.716 202.001 415.187L212.744 403.511",
  stroke: "#4E6CFC",
  strokeWidth: 1.5236,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M204.676 426.635C214.491 426.635 222.447 418.679 222.447 408.865C222.447 399.051 214.491 391.094 204.676 391.094C194.862 391.094 186.906 399.051 186.906 408.865C186.906 418.679 194.862 426.635 204.676 426.635Z",
  stroke: "white",
  strokeWidth: 0.5,
  strokeMiterlimit: 10
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M116.856 157.011C115.601 156.491 114.46 155.752 113.49 154.822C112.493 153.892 111.723 152.797 111.208 151.567C110.637 150.308 110.352 148.995 110.352 147.6C110.352 141.991 115.144 137.421 120.992 137.421C122.645 137.421 124.302 137.803 125.756 138.515C127.211 139.198 128.524 140.266 129.493 141.526L129.95 142.073L126.898 144.236L126.471 143.689C125.188 142.02 123.191 141.061 120.994 141.061C117.23 141.061 114.147 143.989 114.147 147.6C114.147 151.24 117.227 154.195 120.994 154.195C123.163 154.195 125.161 153.238 126.471 151.567L126.898 151.046L129.923 153.18L129.465 153.727C128.468 155.013 127.211 156.026 125.729 156.738C124.274 157.45 122.648 157.806 120.994 157.806C119.568 157.806 118.169 157.532 116.856 157.011Z",
  fill: "#0056D2"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M132.802 155.89C131.519 154.604 130.805 152.935 130.805 151.237C130.805 149.513 131.517 147.844 132.802 146.585C134.115 145.381 135.827 144.695 137.652 144.695C139.536 144.695 141.247 145.378 142.472 146.585C143.785 147.844 144.497 149.486 144.497 151.237C144.497 152.988 143.785 154.63 142.472 155.89C141.189 157.12 139.477 157.806 137.652 157.806C135.885 157.806 134.142 157.123 132.802 155.89ZM134.173 151.237C134.173 153.126 135.741 154.657 137.652 154.657C139.591 154.657 141.162 153.124 141.162 151.237C141.162 149.348 139.594 147.818 137.652 147.818C135.741 147.818 134.173 149.351 134.173 151.237Z",
  fill: "#0056D2"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M163.899 157.505V150.801C163.899 149.351 162.617 148.065 161.132 148.065C159.592 148.065 158.337 149.324 158.337 150.801V157.505H154.772V150.801C154.772 149.324 153.517 148.065 152.004 148.065C150.492 148.065 149.237 149.351 149.237 150.801V157.505H145.672V144.972H149.237V145.875C150.121 145.028 151.063 144.725 152.004 144.725C152.833 144.725 153.658 144.889 154.459 145.216C155.201 145.546 155.885 146.011 156.511 146.585C156.511 146.611 156.539 146.611 156.57 146.64C156.597 146.614 156.597 146.614 156.628 146.585C157.226 146.011 157.91 145.546 158.68 145.216C159.478 144.887 160.306 144.725 161.135 144.725C162.819 144.725 164.415 145.354 165.614 146.476C166.813 147.653 167.467 149.186 167.467 150.799V157.503H163.899V157.505Z",
  fill: "#0056D2"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M180.702 146.614C181.984 147.873 182.699 149.515 182.699 151.237C182.699 152.962 181.987 154.604 180.702 155.861C179.419 157.091 177.708 157.75 175.882 157.75C174.683 157.75 173.6 157.341 172.658 156.52L172.514 156.411V164.783H169.062V144.972H172.514V145.958L172.658 145.822C173.686 144.865 174.854 144.727 175.882 144.727C177.68 144.725 179.389 145.384 180.702 146.614ZM179.248 151.237C179.248 149.43 177.708 147.926 175.882 147.926C174.057 147.926 172.517 149.43 172.517 151.237C172.517 153.015 174.057 154.548 175.882 154.548C177.708 154.548 179.248 153.017 179.248 151.237Z",
  fill: "#0056D2"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M183.98 157.505V137.42H187.689V157.505H183.98Z",
  fill: "#0056D2"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M190.539 141.36C190.539 140.786 190.766 140.265 191.196 139.882C191.622 139.473 192.165 139.253 192.763 139.253C193.963 139.253 194.96 140.209 194.96 141.36C194.96 142.51 193.963 143.467 192.763 143.467C191.539 143.467 190.539 142.508 190.539 141.36ZM190.91 157.504V144.971H194.619V157.504H190.91Z",
  fill: "#0056D2"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M198.614 155.863C197.332 154.604 196.617 152.962 196.617 151.24C196.617 149.515 197.329 147.873 198.614 146.617C199.897 145.386 201.609 144.727 203.434 144.727C204.633 144.727 205.716 145.136 206.658 145.958L206.802 146.066V144.972H210.254V157.505H206.802V156.52L206.658 156.655C205.631 157.612 204.462 157.75 203.434 157.75C201.636 157.75 199.925 157.093 198.614 155.863ZM200.069 151.237C200.069 153.044 201.609 154.548 203.434 154.548C205.259 154.548 206.8 153.044 206.8 151.237C206.8 149.46 205.259 147.926 203.434 147.926C201.609 147.926 200.069 149.46 200.069 151.237Z",
  fill: "#0056D2"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M221.756 157.505V150.801C221.756 149.324 220.528 148.174 218.988 148.174C217.506 148.174 216.221 149.351 216.221 150.801V157.505H212.656V144.972H216.221V145.875C217.105 145.028 218.047 144.725 218.988 144.725C220.7 144.725 222.298 145.354 223.495 146.476C224.694 147.653 225.348 149.186 225.348 150.799V157.503H221.756V157.505Z",
  fill: "#0056D2"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M232.563 157.505C231.308 157.505 230.139 157.04 229.283 156.219C228.4 155.371 227.943 154.276 227.943 153.073V147.873H226.117V145.053H227.943V140.127H231.336V145.053H235.131V147.873H231.336V153.017C231.336 153.7 231.965 154.329 232.591 154.329H235.072L235.984 157.505H232.563Z",
  fill: "#0056D2"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M104.8 158.187H110.515C110.936 158.187 111.183 157.743 110.939 157.422L95.03 136.285C94.933 136.154 94.7751 136.077 94.6061 136.077H88.8914C88.4703 136.077 88.2238 136.521 88.4675 136.843L104.376 157.98C104.471 158.11 104.631 158.187 104.8 158.187Z",
  fill: "#0056D2"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M94.7896 158.256H88.4903C88.1385 158.256 87.9308 157.873 88.1358 157.597L96.0777 146.918C96.1802 146.78 96.3492 146.695 96.5265 146.695H102.552C102.995 146.695 103.255 147.168 103 147.513L95.1414 158.081C95.0611 158.192 94.9309 158.256 94.7896 158.256Z",
  fill: "#00E7C5"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M103.337 142.447C104.919 142.447 106.201 141.217 106.201 139.699C106.201 138.182 104.919 136.952 103.337 136.952C101.755 136.952 100.473 138.182 100.473 139.699C100.473 141.217 101.755 142.447 103.337 142.447Z",
  fill: "#00E7C5"
});

function SvgPaymentMethod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 562,
    viewBox: "0 0 355 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.22ee2d28.svg";
export { ForwardRef as ReactComponent };